import React from 'react'
import { Canvas } from 'react-three-fiber'
import {
  Helpers,
  ZoomCamera,
  Lights,
  CaptureDragRotate
} from '../../three'
import ModelViewerModel from './ModelViewerModel'
import { getStepValues } from '../../../shared/utils'

const cameraDefaults = {
  aspect: window.innerWidth / window.innerHeight,
  position: [10, 15, 10]
}

function ModelViewerCanvas({
  model,
  zoom,
  rotation,
  autoRotate,
  setZoom,
  setRotation,
  ...props
}) {
  return model ? (
    <CaptureDragRotate
      initialRotation={rotation}
      initialZoom={zoom}
      onZoom={setZoom}
      zoomConfig={{
        bounds: model.zoomBounds,
        steps: getStepValues(model.zoomBounds, 10),
        increment: 0.0001
      }}
      onRotate={setRotation}
      {...props}>
      <Canvas
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <ZoomCamera
          zoom={zoom}
          focalPoint={model.position}
          {...cameraDefaults}
        />
        <Lights />
        <React.Suspense fallback={<mesh />}>
          <ModelViewerModel
            model={model}
            rotation={rotation}
            autoRotate={autoRotate}
            onRotate={setRotation}
          />
        </React.Suspense>
        <Helpers axis={false} base={true} />
      </Canvas>
    </CaptureDragRotate>
  ) : null
}

export default ModelViewerCanvas
